__turbopack_context__.v({
  "className": "roboto_slab_661b3ddd-module__52J5kG__className",
});
